import { createElement } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { ToastSuccessIcon } from '@components/icons';

const defaultOptions: ToastOptions = {
  autoClose: 4000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
};

class ToastService {
  success(message: string, options: ToastOptions = {}) {
    toast.success(message, { ...defaultOptions, icon: () => createElement(ToastSuccessIcon), hideProgressBar: true, ...options });
  }

  error(message: string, options: ToastOptions = {}) {
    toast.error(message, { ...defaultOptions, ...options });
  }

  info(message: string, options: ToastOptions = {}) {
    toast.info(message, { ...defaultOptions, ...options });
  }

  warn(message: string, options: ToastOptions = {}) {
    toast.warn(message, { ...defaultOptions, ...options });
  }

  warning(message: string, options: ToastOptions = {}) {
    toast.warn(message, { ...defaultOptions, ...options });
  }
}

export const toastService = new ToastService();